import { createApp } from 'vue';
import App from './App.vue';
import router from './router'
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap';

import MyModal from'@/components//helpers/MyModal';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

const app = createApp(App);

app.use(router)
app.component('MyModal', MyModal);
app.component('VueDatePicker', VueDatePicker);

app.mount('#app');